import React from "react";
import { FaEnvelope } from "react-icons/fa";

const FALLBACK_PERSON = "/img/no-image.jpg";

export default function MemberCard({ p, compact = false }) {
  const emailHref = p?.email ? `mailto:${p.email}` : null;

  const commissions =
    Array.isArray(p?.commissions)
      ? p.commissions.map((x) => x?.nom_commission || x).filter(Boolean)
      : (p?.commission?.nom_commission ? [p.commission.nom_commission] : []);

  const sizeCls = compact
    ? "w-16 h-16 md:w-16 md:h-16"
    : "w-24 h-24 md:w-24 md:h-24";

  return (
    <div className="group rounded-2xl p-4 bg-white/90 dark:bg-slate-800/80 ring-1 ring-slate-200/70 dark:ring-slate-700/70 hover:shadow transition">
      <div className="flex items-center gap-4">
        <img
          src={p?.photo_url?.trim() ? p.photo_url : FALLBACK_PERSON}
          alt={`${p?.prenom ?? ""} ${p?.nom ?? ""}`}
          onError={(e) => {
            e.currentTarget.src = FALLBACK_PERSON;
          }}
          className={`${sizeCls} rounded-full object-cover ring-2 ring-white shadow`}
        />
        <div className="min-w-0">
          <h4 className="font-semibold text-slate-900 dark:text-white truncate">
            {(p?.prenom || "") + " " + (p?.nom || "")}
          </h4>

          {/* Fonction (pas en tag) */}
          {p?.poste ? (
            <div className="text-sm text-slate-700 dark:text-slate-200">
              {p.poste}
            </div>
          ) : null}

          {/* Commissions */}
          {commissions.length > 0 ? (
            <div className="text-xs text-slate-600 dark:text-slate-300 mt-1">
              Commission{commissions.length > 1 ? "s" : ""} :{" "}
              <span className="font-medium">
                {commissions.join(", ")}
              </span>
            </div>
          ) : null}

          {/* Email */}
          {emailHref ? (
            <a
              href={emailHref}
              className="inline-flex items-center gap-1 text-xs mt-2 text-indigo-600 dark:text-indigo-400 hover:underline"
            >
              <FaEnvelope /> {p.email}
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
